<div class="emoji-user-lists">
  <div class="emoji-user" *ngFor="let user of users$ | async">
    <app-user-avatar [user]="user" [showFullName]="false"></app-user-avatar>
    <span class="ml-2" [ngClass]="{'font-weight-bold': isExistedMe(user)}">{{user.fullName}}</span>
  </div>
</div>
